var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPanelEfficiency = function SvgPanelEfficiency(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3B3F44",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    clipPath: "url(#panelEfficiency_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.125 11.212 21.84 2.246M18.154.857l3.686 1.389-1.371 3.686M22.714 23.143H18.43v-12a.86.86 0 0 1 .857-.857h2.571a.857.857 0 0 1 .857.857zM14.143 23.143H9.857v-9.428a.857.857 0 0 1 .857-.858h2.572a.857.857 0 0 1 .857.858zM5.571 23.143H1.286v-6.857a.857.857 0 0 1 .857-.857h2.571a.857.857 0 0 1 .857.857z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "panelEfficiency_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgPanelEfficiency;